// src/locales/en/business.js
export const business = {
    business: "வணிகம்",
    businessName: "வணிக பெயர்",
    businessInfo: "வணிக தகவல்"
}